import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { Store } from '@ngrx/store';
import { ServiceService } from '../../../../../../services/service.service';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface State {
}

const defaultState: State = {};

@Injectable()
export class ServiceNursingCareDiagnosisGroupDialogStore extends ComponentStoreFactory<State> {
    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }
}
